/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { messagesCountsGetApiV3MessagesCounts } from "../../funcs/messagesCountsGetApiV3MessagesCounts.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3MessagesCountsRequest$inboundSchema.optional(),
};

export const tool$messagesCountsGetApiV3MessagesCounts: ToolDefinition<
  typeof args
> = {
  name: "messages-counts-get-api-v3-messages-counts",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await messagesCountsGetApiV3MessagesCounts(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
